<div class="stamp">
  <img src="/assets/img/icons/stamp-light.png" alt="stamp"/>
</div>
